export enum SERVICE_INPUT_ID {
    CONTACT_NUMBER = 1,
    SIM_NUMBER = 2,
    IDENTIFICATION_NUMBER = 3,
    RECHARGE_NUMBER = 4,
    DEVICE_NUMBER = 5,
    START_DATE = 6,
    END_DATE = 7,
    START_TIME = 8,
    END_TIME = 9,
    ACCOUNT_NUMBER = 10,
    TOWER_NUMBER = 11,
    COORDINATES = 12,
    CAB_NUMBER = 13,
    CIRCUIT_NUMBER = 14,
    MODEM_NUMBER = 15,
    IP_ADDRESS = 16,
    PLAT_INFO=17,
    SLIDE_NUMBER=18,
    CUSTOMER_NAME=19,
    CUSTOMER_ID=20



}
